"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.genNewUuid = void 0, exports.daysDiff = daysDiff, exports.daysDiffAbs = daysDiffAbs;

var _formatting = require("./formatting"),
    _uuid = require("uuid"),
    genNewUuid = exports.genNewUuid = _uuid.v4;

function daysDiff(a, b) {
  var c = (0, _formatting.formatOdooDate2Sys)(a),
      d = (0, _formatting.formatOdooDate2Sys)(b),
      e = Math.round((c - d) / 86400000);
  return e;
}

function daysDiffAbs(a, b) {
  var c = daysDiff(a, b);
  return 0 < c ? c : -c;
}